import { z } from "zod";

export const codeSchema = z.object({
  code: z.number(),
  type: z.number(),
  name: z.string(),
});

export type CodeType = z.infer<typeof codeSchema>;
